import { useFilterChangeCallback } from 'shared/hooks';
import { FILTER_KEY } from '../constants';
import { NonEmptyArray, ERoomType } from '../../../../packages/JsonQuery';
import { useCallback } from 'react';

export const useRoomTypeChangeHandler = () => {
  const onChange = useFilterChangeCallback(FILTER_KEY);

  return useCallback(
    (roomType: NonEmptyArray<ERoomType>) => {
      onChange({ action: 'setRoomTypes', arguments: [roomType] });
    },
    [onChange],
  );
};
